<template>
  <span>{{ showingId }}</span>
  <CIcon v-if="false" class="icon" icon="cil-code" @click="toggleId()" />
</template>

<script>
import Hashids from 'hashids'

export default {
  name: 'IdLabel',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showingId: this.id,
    }
  },
  computed: {
    unhashedId() {
      return this.unhashId(this.id)
    },
  },
  methods: {
    unhashId(id) {
      var hashids = new Hashids('', 8, '')
      return hashids.decode(id)[0]
    },
    toggleId() {
      if (this.showingId == this.id) {
        this.showingId = this.unhashedId
      } else {
        this.showingId = this.id
      }
    },
  },
}
</script>

<style scoped>
.icon {
  margin-left: 7px;
  cursor: pointer;
}
</style>
